// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const FeedItemRecord = require('client-v2/common/containers/feed/records/item')
const { keyedReviver, listReviver } = require('client-v2/common/state/record-reviver')
const { FetchStateEnum } = require('client-v2/common/utils/enums')

class ShareFriendRecord extends Immutable.Record({
  id: Number(),
  'display_name': String(),
  isSelected: Boolean(),
  'photo_url': String(),
  username: String()
}) {
  // No methods
}

ShareFriendRecord.reviver = keyedReviver(ShareFriendRecord, {
  // No nested data structures
})

class ShareModalRecord extends Immutable.Record({
  feedItem: null,
  friends: Immutable.List(),
  friendsState: FetchStateEnum.EMPTY,
  searchText: String(),
  submitState: FetchStateEnum.EMPTY
}) {
  showModel(model) {
    return this.merge({
      feedItem: FeedItemRecord.fromModel(model)
    })
  }

  reset() {
    return this.merge({
      feedItem: null,
      friends: this.friends.map(friend => friend.set('isSelected', false)),
      searchText: '',
      submitState: FetchStateEnum.EMPTY
    })
  }

  toggleFriend(userId) {
    const index = this.friends.findIndex(item => item.id === userId)
    if (index === -1) {
      return this
    }
    return this.update('friends', friends => {
      return friends.update(index, friend => {
        return friend.set('isSelected', !friend.isSelected)
      })
    })
  }
}

const friendsReviver = listReviver(ShareFriendRecord.reviver)
ShareModalRecord.reviver = keyedReviver(ShareModalRecord, {
  feedItem: FeedItemRecord.reviver,
  friends: friendsReviver
})

module.exports = Object.assign(ShareModalRecord, {
  friendsReviver
})
